import { CalendarDateService } from '@uplift/services';
import { useTimezone } from '@uplift/contexts';
import { useL10n } from '@uplift/hooks';


export const useNextAvailableDateFormatted = (date?: string) => {
  const timezone = useTimezone();
  const l10n = useL10n();

  if (!date) {
    return l10n.matching.providers.noDateAvailable;
  }

  return CalendarDateService.date(date).tz(timezone).format('ddd, MMM D');
};
